var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mal-sale-body"},[_c('card-body'),_c('store-body'),_c('category-goods-show')],1)}
var staticRenderFns = []

export { render, staticRenderFns }